import {
  fetchValidateAddressWeb,
  IValidateAddressWebRequest,
  TValidateAddressWebResponse,
} from 'shared/repositories/price-estimator/v1/validate-address-web';
import { IApplicationContext } from 'shared/types/applicationContext';

export const fetchValidateAdress = async ({ httpApi }: IApplicationContext, params: IValidateAddressWebRequest) => {
  const response = await fetchValidateAddressWeb<TValidateAddressWebResponse, TValidateAddressWebResponse>({
    httpApi,
    parameters: params,
  });

  return response;
};
